export default {
  title: 'データレポート',
  salesReport: '売上レポート',
};
